import { isNull, isUndefined } from 'lodash';
import { Instance, types } from 'mobx-state-tree';

import { withEnvironment } from '../../models/extensions/with-environment';
import { createAuthDefaultModel } from '../auth/Auth';
import { IAuthUser, IAuthUserSnapshot } from '../auth-user/AuthUser';
import { createLoginResponse, ILoginResponse } from '../login-response/LoginResponse';

import { AuthApi } from './../../services/auth/auth-api';
import { LoginResponseTypeResult } from './../../services/auth/auth-result-types';
import { withRootStore } from './../extensions/with-root-store';

export const LOGIN_USER_STORAGE_NM = 'loginUser';

export const AuthStoreModel = types
  .model('AuthStore')
  .props({
    authStatus: createAuthDefaultModel(),
    loginResponse: createLoginResponse(),
    expiredOpener: types.optional(types.boolean, false),
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  .actions((self) => ({
    // 로그인 성공 후 처리
    processAfterLoginSuccess: async (user: IAuthUserSnapshot) => {
      window.sessionStorage.setItem(LOGIN_USER_STORAGE_NM, JSON.stringify(user));
      self.authStatus.isInitialized = true;
      self.authStatus.isAuthenticated = true;
      self.expiredOpener = false;
    },

    // 로그아웃 후 처리
    processAfterLogout: async () => {
      window.sessionStorage.removeItem(LOGIN_USER_STORAGE_NM);
      self.authStatus.isInitialized = true;
      self.authStatus.isAuthenticated = false;
      self.rootStore.errorAlertStore.resetErrorAlert();
    },

    // sessionStorage에서 사용자 정보 가져오기
    getLoginUserStorageData: (): IAuthUserSnapshot | null => {
      const userStr: string | null = window.sessionStorage.getItem(LOGIN_USER_STORAGE_NM);
      if (userStr) {
        try {
          const user: IAuthUserSnapshot = JSON.parse(userStr) as IAuthUser;
          if (isNull(user?.userSid) || isUndefined(user?.userSid)) {
            return null;
          }
          return user;
        } catch (error) {
          window.sessionStorage.removeItem(LOGIN_USER_STORAGE_NM);
          return null;
        }
      }
      return null;
    },

    // 초기화 - sessionStorage에서 인증 상태 복원
    initialize: () => {
      // MobX-State-Tree의 actions 블록 내에서 다른 액션을 호출할 때 TypeScript가
      // self에 해당 액션이 존재하지 않는다고 잘못 추론하는 경우가 있습니다.
      // 이 문제를 해결하기 위해 self를 'any'로 캐스팅하여 타입 검사를 우회합니다.
      const user = (self as any).getLoginUserStorageData();
      self.authStatus.isInitialized = true;
      self.authStatus.isAuthenticated = !!user;
    },

    setLoginResponse: (loginResponse: ILoginResponse) => {
      self.loginResponse = loginResponse;
    },

    errorLoginResponse: (loginResponse: ILoginResponse) => {
      // errorLoginResponse: (errorMessage = '') => {
      self.loginResponse = loginResponse;
      // {
      //   resultCode: 'F',
      //   message: errorMessage,
      //   data: null,
      // } as ILoginResponse;
    },
  }))
  .actions((self) => ({
    // 로그인 처리
    // loginProcess: async (userId: string, userPwd: string) => {
    //   try {
    //     const authApi: AuthApi = new AuthApi(self.environment.api);
    //     const result: LoginResponseTypeResult = await authApi.loginProcess(userId, userPwd);

    //     if (result?.loginResponse) {
    //       self.setLoginResponse(result.loginResponse);

    //       if (result.loginResponse.resultCode === 'S' && result.loginResponse.data) {
    //         const userInfo: IAuthUserSnapshot = {
    //           userSid: result.loginResponse.data.userSid || 0,
    //           userId: userId,
    //           userNm: result.loginResponse.data.userNm || '',
    //         };
    //         await self.processAfterLoginSuccess(userInfo);
    //       }
    //       return result;
    //     } else {
    //       self.errorLoginResponse('로그인 응답을 받지 못했습니다.');
    //       throw new Error('로그인 응답 없음');
    //     }
    //   } catch (e) {
    //     self.errorLoginResponse('로그인 중 오류가 발생했습니다.');
    //     throw e;
    //   }
    // },
    // loginProcess: async (userId: string, userPwd: string) => {
    //   try {
    //     const authApi: AuthApi = new AuthApi(self.environment.api);
    //     const result: LoginResponseTypeResult = await authApi.loginProcess(userId, userPwd);

    //     console.log('전체 result:', result);

    //     if (result?.loginResponse) {
    //       // UI용 응답 구성 (TGeneralApiResponse에서 가져오기)
    //       const uiResponse = {
    //         resultCode: (result as any).resultCode || 'S',
    //         message: (result as any).message || '',
    //         data: (result as any).data || result.loginResponse, // 실제 데이터를 data로 설정
    //       };
    //       self.setLoginResponse(uiResponse as ILoginResponse);

    //       // 성공 여부는 TGeneralApiResponse의 resultCode로 판단
    //       const isSuccess = (result as any).resultCode === 'S' || (result as any).kind === 'ok';

    //       if (isSuccess && result.loginResponse) {
    //         // result.loginResponse에서 직접 사용자 데이터 가져오기
    //         // any 타입으로 캐스팅해서 TypeScript 오류 회피
    //         const loginData = result.loginResponse as any;

    //         const userInfo: IAuthUserSnapshot = loginData;
    //         //  {
    //         //   userSid: loginData.userSid,
    //         //   userId: loginData.userId || userId,
    //         //   userNm: loginData.userNm,
    //         // };

    //         console.log('저장할 사용자 정보:', userInfo);
    //         await self.processAfterLoginSuccess(userInfo);
    //       }
    //       return result;
    //     } else {
    //       self.errorLoginResponse({ ...result, message: result });
    //       throw new Error('로그인 응답 없음');
    //     }
    //   } catch (e) {
    //     self.errorLoginResponse({ message: '로그인 중 오류가 발생했습니다22.' });
    //     throw e;
    //   }
    // },
    loginProcess: async (userId: string, userPwd: string) => {
      try {
        const authApi: AuthApi = new AuthApi(self.environment.api);
        const result: LoginResponseTypeResult = await authApi.loginProcess(userId, userPwd);

        // result.kind가 'ok'이고 responseInfo가 있는 경우
        if (result.kind === 'ok' && (result as any).responseInfo) {
          const responseInfo = (result as any).responseInfo;

          // responseInfo를 그대로 loginResponse로 설정
          self.setLoginResponse(responseInfo);

          // 성공 여부 판단
          const isSuccess = responseInfo.resultCode === 'S';

          if (isSuccess && responseInfo.data) {
            const userInfo: IAuthUserSnapshot = responseInfo.data;

            await self.processAfterLoginSuccess(userInfo);
          }
          return result;
        } else {
          // responseInfo가 없는 경우
          const errorResponse = {
            resultCode: 'F',
            message: '로그인 응답을 받지 못했습니다.',
            data: null,
          };
          self.errorLoginResponse(errorResponse as ILoginResponse);
          throw new Error('로그인 응답 없음');
        }
      } catch (e) {
        const errorResponse = {
          resultCode: 'F',
          message: '로그인 중 오류가 발생했습니다.',
          data: null,
        };
        self.errorLoginResponse(errorResponse as ILoginResponse);
        throw e;
      }
    },
    // 로그아웃
    // logout: async () => {
    //   try {
    //     const authApi: AuthApi = new AuthApi(self.environment.api);
    //     await authApi.logout();
    //   } catch (e) {
    //     console.error('서버 로그아웃 오류:', e);
    //   } finally {
    //     await self.processAfterLogout();
    //   }
    // },
    logout: () => {
      // sessionStorage 클리어
      window.sessionStorage.removeItem(LOGIN_USER_STORAGE_NM);

      // 인증 상태 초기화
      self.authStatus.isInitialized = true;
      self.authStatus.isAuthenticated = false;

      // 에러 알림 초기화
      self.rootStore.errorAlertStore.resetErrorAlert();

      // 페이지 새로고침으로 완전 초기화 (선택사항)
      // window.location.reload();
    },
  }));

type AuthStoreType = Instance<typeof AuthStoreModel>;
export interface AuthStore extends AuthStoreType {}
